export default function ({ singleSpa, isValidName }) {
  const validateDomainName = (apps, appName) => {
    if (!isValidName(apps, appName)) {
      const message = `domain [${appName}] is duplicated`
      throw new Error(JSON.stringify({ message: `[${process.env.APP_NAME}] > ${message}` }))
    }
  }

  return (domains, authenticated) => {
    const { apps } = domains || {}
    if (!apps || !Array.isArray(apps)) return

    try {
      apps
        .filter(({ auth }) => authenticated || !auth)
        .forEach((app) => {
          const { name, dependencies, rules } = app
          validateDomainName(apps, name)

          singleSpa.registerApplication(name, dependencies, rules, {})
        })

      singleSpa.start()
    } catch (ex) {
      throw new Error(JSON.stringify({
        message: `[${process.env.APP_NAME}] > apps registration > ${ex}`,
        error: ex.message,
      }))
    }
  }
}
